import { AlertTriangle } from "lucide-react";

export function formatTimeRemaining(seconds) {
  const safeSeconds = Math.max(0, Number(seconds) || 0);
  const minutes = Math.floor(safeSeconds / 60);
  const rest = safeSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(rest).padStart(2, "0")}`;
}

export default function ImpersonationBanner({ session, ending = false, onEnd }) {
  if (!session) return null;

  return (
    <div className="sticky top-0 z-[70] flex flex-wrap items-center justify-between gap-3 bg-red-700 px-4 py-3 text-sm font-semibold text-white shadow-lg">
      <div className="flex min-w-0 flex-wrap items-center gap-2">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span className="truncate">
          IMPERSONATING {session.target_user_name || "Unknown user"}
        </span>
        <span aria-hidden="true">·</span>
        <span>{session.target_user_role || "user"}</span>
        <span aria-hidden="true">·</span>
        <span className="truncate">{session.clinic_name || "Unknown clinic"}</span>
        <span aria-hidden="true">·</span>
        <span>{formatTimeRemaining(session.seconds_remaining)} remaining</span>
      </div>
      <button
        type="button"
        onClick={onEnd}
        disabled={ending}
        className="shrink-0 rounded-md border border-white/70 px-3 py-1.5 text-xs font-bold uppercase tracking-normal text-white hover:bg-white hover:text-red-700 disabled:opacity-60"
      >
        {ending ? "Ending..." : "End Session"}
      </button>
    </div>
  );
}
